export const sortPublishedAsc = (a: any, b: any) => {
  const ca = a?.published_at || 'Z';
  const cb = b?.published_at || 'Z';

  if (ca > cb) {
    return 1;
  }
  if (ca < cb) {
    return -1;
  }
  return 0;
};

export const sortPublishedDesc = (a: any, b: any) => {
  const ca = a.published_at || '0';
  const cb = b.published_at || '0';

  if (ca < cb) {
    return 1;
  }
  if (ca > cb) {
    return -1;
  }
  return 0;
};
